<template>
    <b-form-group v-bind="$attrs" :label="label" :description="description">
        <template slot="label">
            {{label}}<span class="text-danger" v-if="required">*</span>
        </template>
        <slot></slot>
    </b-form-group>
</template>

<script>
    export default {
        name: "FormGroup",
        props: {
            label: null,
            description: null,
            required: {type: Boolean, default: false}
        }
    }
</script>